<template>
  <div id="course_pay_entry_outer" >
    <div id="course_pay_desc" v-html="itemData.notice"></div>

    <div class="label-title" v-if="false" style="margin-top: 20px;">报名前需要准备如下材料：</div>
    <div v-if="false" class="download-list" >
      <a v-for="(item, index) in templateList" :key="'training-template-' + index"
         target="_blank"
         :href="item"
         :download="resourceName(item)">{{resourceName(item)}}</a>
    </div>

    <div class="bottom-buttons" style="text-align: center;margin-top: 30px;">
      <el-button class="entry-doing" @click="courseSignClicked" v-if="status == 1" >立即报名</el-button>
      <el-button class="entry-ready" disabled v-else-if="status == 0">敬请期待</el-button>
      <el-button class="entry-done" disabled v-else-if="status == 2">报名已结束</el-button>
      <el-button class="entry-done" disabled v-else-if="status == 3">报名人数已满</el-button>
      <el-button class="entry-done" disabled v-else-if="status == 4" >审核中</el-button>
      <el-button class="entry-doing" @click="courseSignClicked" v-if="status == 5" >支付培训费</el-button>

      <el-button class="entry-done" disabled v-else-if="status == 6">已报名</el-button>
      <el-button class="entry-doing" @click="courseSignClicked" v-if="status == 7" >报名失败，重新提交</el-button>
      <el-button class="entry-done" disabled v-else-if="status == 8" >支付过期，报名失败</el-button>
      <el-button class="entry-doing" @click="courseSignClicked" v-if="status == 9" >签署防疫承诺书</el-button>

    </div>

    <course-user-info-pop v-if="showPop"
                          v-bind:step="stepValue"
                          v-bind:current-order="currentOrder"
                          v-bind:item-data="itemData"
                          v-bind:pay-data="payInforData"
                          v-bind:product-id="trainingId"
                          v-on:submit-user-infors-success="submitUserInforsSuccess"
                          v-on:submit-user-healths-infros-success="submitHealthsInforsSuccess"
                          v-on:payClicked="jsApiPayButtonClicked"
                          v-on:closePop="closePop"></course-user-info-pop>

    <login-dialog v-if="showLoginDialog" v-on:close="closeLoginDialog"></login-dialog>
  </div>
</template>

<script>
  import CourseUserInfoPop from "./CourseUserInfoPop";
  import WeixinManager from "../../js/weixin.config";
  import LoginDialog from "../common/LoginDialog";
export default {
  name: "CoursePayEntry",
  props: [
    'itemData',
  ],
  components: {
    LoginDialog,
    CourseUserInfoPop
  },
  data() {
    return {
      showPop: false,
      status: 0, // 0 未开始, 1 进行中 2 已结束, 3 报名人数已满, 4 审核中, 5 待付款, 6 已付款（报名成功）,7 审核失败 8 支付过期

      payInforData: null,
      showQrCode: true,
      neededAutoCheckPayStatus: false,
      code: null,
      wechatData: null,
      checkInterval: null,
      testObj: null,

      showLoginDialog: false,
      isLogined: false,
      orderList: null,
      currentOrder: null,
      stepValue: 0,
      intervalCount: 0,
    }
  },

  watch: {
    itemData(val) {
      this.status = this.caculateStatus();
      this.dealWithStepValue();
      if (this.status == 5) {
        this.loadQrCodeData();
      }
    },
  },

  destroyed() {
    this.closeInterval();
    this.eventManager.unregister('course-pay-entry', this.eventManager.notificationNameObject.UserUpdate);
  },

  computed: {
    eventManager() {
      return this.$store.state.eventManager;
    },

    templateList() {
      if (this.itemData == null || this.itemData == undefined) {
        return [];
      }

      let template = this.itemData.template;
      if (template == null || template == '') {
        return [];
      }

      return template.split(',');
    },

    httpManager() {
      return this.$store.state.http;
    },
    index() {
      return this.$route.params.index;
    },
    trainingId() {
      return this.$route.params.courseId;
    },
  },
  mounted() {
    this.initPayParams();
    let query = this.$route.query;
    let state = query.state;
    let _this = this;
    this.eventManager.register('course-pay-entry', this.eventManager.notificationNameObject.UserUpdate, function () {
      let user = _this.$store.state.dataStore.getUser();
      _this.checkNeedsLogin();
      // _this.tempUserName =  user == null ? null : user.nickName;
    });

    if (state == this.weichatAutoState.login || state == 1001) {
      this.showLoginDialog = true;
    } else {
      this.checkNeedsLogin();
    }
    this.dealWithStatus();

  },
  methods: {


    initPayParams() {
      if (this.isPc()) { // pc端
        this.tradeType = 'NATIVE';
        this.showQrCode = true;
        this.neededAutoCheckPayStatus = true;
      } else { // 移动端
        this.showQrCode = false;
        if (this.isWeixin()) {
          this.tradeType = 'JSAPI';
          this.neededAutoCheckPayStatus = false;
        } else {
          this.tradeType = 'MWEB';
          this.neededAutoCheckPayStatus = true;
        }
      }
    },


    submitHealthsInforsSuccess() {
    },

    submitUserInforsSuccess() {
      this.loadUserOrderData();
    },

    dealWithStatus() {
      this.status = this.caculateStatus();
      this.dealWithStepValue();
      if (this.status == 5) {
        this.initAutoCode();
        this.loadQrCodeData();
      }
    },

    resourceName(url) {
      if (url == undefined || url == null) {
        return '';
      }

      let tmp = url.split('/');
      return tmp[tmp.length - 1];
    },


    jsApiPayButtonClicked() {
      let params = this.payInforData;
      if (params == null) {
        return;
      }

      if (this.tradeType == 'JSAPI') {
        let _this = this;
        WeixinManager.jsapi_sendPayRequest(params, function (data) {
          // _this.showPop = false;
          _this.checkPayStatus();
        }, function (data) {
          // loadFlags.close();
          // console.log('请求失败');
          // _this.$toast(data.err_msg);
        });
      } else {
        let mwebUrl = params.mwebUrl;
        if (mwebUrl != null && mwebUrl.length > 0) {
          let url =  window.location.href;
          if (this.isSafari()) {
            url += "?outTradeNo=" + params.outTradeNo;
            url = encodeURI(url);
          }
          mwebUrl += '&redirect_url=';
          mwebUrl += url;
          window.open(mwebUrl, '_self');
        }
      }
    },

    checkNeedsLogin() {
      let _this = this;
      this.checkToken(this.$store,function (data) {
        let code = data.code;
        _this.isLogined = code == 0;
        if (_this.isLogined) {
          _this.loadUserOrderData();
        }
      });
    },

    loadQrCodeData() {
      if (this.payInforData != null) {
        return;
      }
      if (!this.showQrCode && this.code == null) {
        return;
      }
      if (this.currentOrder == undefined || this.currentOrder == null) {
        return;
      }
      let productId = this.currentOrder.id;
      let params = {
        productId: productId,
        tradeType: this.tradeType
      };

      if (this.code != null) {
        params.code = this.code;
      }

      let _this = this;
      this.httpManager.ajax.getPayUnifiedorderData(params, function (data) {
        console.log(data);
        let code = data.code;
        if (code == 0) {
          _this.payInforData = data.data;
          _this.code = null;
          if (_this.neededAutoCheckPayStatus) {
            _this.startInterval();
          }
          return;
        }
      }, function (data) {
        console.log(data);
      });
    },

    weichatPaySuccess() {
      this.$toast('支付成功！');
      if (this.showPop) {
        this.showPop = false;
      }
      this.$emit('paySuccess');
    },

    checkPayStatusAtBegin(outTradeNo) {
      let params = {
        outTradeNo
      };
      let _this = this;
      this.checkInterval = null;
      this.httpManager.ajax.getPayWxPayCheckData(params, function (data) {
        let code = data.data;
        if (code == 1) {
          _this.showPop = false;
          _this.weichatPaySuccess();
          _this.$router.push({
            name: _this.$route.name,
            params: _this.$route.params,
            query: {}
          });
          _this.loadUserOrderData();
        } else {
          _this.startInterval();
        }
      }, function (data) {
        _this.startInterval();
      });
    },


    checkPayStatus() {
      if (this.payInforData == null) {
        return;
      }
      let outTradeNo = this.payInforData.outTradeNo;
      let params = {
        outTradeNo
      };
      let _this = this;
      console.log(params);
      this.checkInterval = null;
      this.httpManager.ajax.getPayWxPayCheckData(params, function (data) {
        let code = data.data;
        if (code == 1) {
          _this.showPop = false;
          _this.weichatPaySuccess();
          _this.loadUserOrderData();
        } else {
          _this.startInterval();
        }
      }, function (data) {
        _this.startInterval();
      });
    },

    startInterval() {
      if (this.checkInterval != null) {
        return;
      }
      if (!this.neededAutoCheckPayStatus || this.payInforData == null) {
        return;
      }
      // this.intervalCount += 1;
      // let timeValue = 5 * 1000 * ( Math.pow(this.intervalCount, 2) - this.intervalCount + 1);

      let timeValue = 10 * 1000;
      this.checkInterval = setTimeout(this.checkPayStatus, timeValue);
    },
    closeInterval() {
      if (this.checkInterval != null) {
        clearTimeout(this.checkInterval);
        this.checkInterval = null;
      }
    },

    closeLoginDialog() {
      this.showLoginDialog = false;
    },

    initAutoCode() {
      let query = this.$route.query;
      let state = query.state;
      if (state == this.weichatAutoState.login) {
        return;
      }

      if (this.tradeType == 'JSAPI') {
        if (state == this.weichatAutoState.pay) {
          let code = query.code;
          if (code != undefined) {
            this.code = code;
            this.$router.push({
              name: this.$route.name,
              params: this.$route.params,
              query: {}
            });
          }
        } else {
          let redirect_url = window.location.href;
          WeixinManager.jsapi_payAutorize(redirect_url);
        }
      }  else if (this.tradeType == 'MWEB') {
        let query = this.$route.query;
        let outTradeNo = query.outTradeNo;
        if (outTradeNo != undefined && outTradeNo != null && outTradeNo.length > 0) {
          //...更新状态
          this.checkPayStatusAtBegin(outTradeNo);
        }
      }
    },

    caculateStatus() {
      let itemData = this.itemData;
      let currentOrder = this.currentOrder;
      let status = 0;
      if (itemData == undefined || itemData == null) {
        return status;
      }

      let startTime = itemData.regStartTime;
      let endTime = itemData.regEndTime;

      if (startTime == null) {
        return status;
      }

      let startDate = this.$moment(startTime);
      let now = this.$moment();
      if (now - startDate < 0) {
        return status;
      } else {
        if (endTime == null) {
          status = 1;
        } else {
          let endDate = this.$moment(endTime);
          if (now - endDate > 0) { // 已结束
            status = 2;
          } else {
            status = 1;
          }
        }
      }

      if (currentOrder == null || status != 1) {
        return status;
      }

      // 报名进行中
      let quota = itemData.quota;
      let payers = itemData.payers;
      if (quota == null || payers == null || quota <= 0) {
        return status;
      }
      if (payers >= quota) {
        status = 3;
        return status;
      }

      let personStatus = currentOrder.status;
      if (personStatus == 0) {
        status = 4; // 审核中
      } else if (personStatus == 1) { // 已付款, 成功
        status = 6;
      } else if (personStatus == 2) { // 申请通过，未付款
        let step = currentOrder.step;
        if (step == 1) { // 签署防疫协议书
          status = 9;
        } else if (step == 2) { // 待付款
          status = 5;
        }
      } else if (personStatus == 3) { // 订单过期
        status = 8;
      } else if (personStatus == 4) { // 未通过
        status = 7;
      }
      return status;
    },

    loadUserOrderData() {
      let _this = this;
      let params = {
        productId: this.trainingId
      };
      this.httpManager.ajax.getTrainOrderData(params,function (data) {
        console.log('----1');
        console.log(data);
        let code = data.code;
        if (code == 0) {
          _this.currentOrder = data.data;
          // _this.orderList = data.data;

          _this.dealWithOrderList();
          return;
        }
      }, function (data) {
        _this.$toast('请求失败，请刷新！');
      });
    },

    dealWithOrderList() {
      // let trainingId = this.trainingId;
      // if (this.orderList == null || this.orderList.length == 0) {
      //   return;
      // }

      // this.currentOrder = this.orderList[0];
      this.dealWithStatus();
      this.$emit('updateCurrentOrder', {current: this.currentOrder});

      // for(let i = 0; i < this.orderList.length; i++) {
        // let item = this.orderList[i];
        // if (trainingId == item.productId) {
          // this.currentOrder = item;
          // this.dealWithStatus();
          // this.$emit('updateCurrentOrder', {current: this.currentOrder});
          // console.log(this.currentOrder);
          // break;
        // }
      // }
    },

    courseSignClicked() {
      if (this.isLogined == false) {
        let _this = this;
        this.$confirm('您尚未登录，请先登录！', '提示', {
          confirmButtonText: '去登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let newLocation = _this.$router.resolve({
            name: 'loginPage'
          });
          _this.showLoginDialog = true;
        }).catch(() => {
        });
        return;
      }

      this.showPop = true;
    },
    dealWithStepValue() {
      let status = this.status;
      if (status == 1) {
        this.stepValue = 0;
        // this.stepValue = 1;
      } else if (status == 9) {
        this.stepValue = 1;
      } else if (status == 5) {
        this.stepValue = 2;
      }
    },
    closePop() {
      this.showPop = false;
    }
  }
}
</script>

<style scoped>

  #course_pay_entry_outer {
    width: 100%;
    padding-bottom: 20px;
  }

  #course_pay_desc {
    margin-top: 10px;
  }

  #course_pay_entry_outer .label-title {
    text-align: center;
    font-size: 1.3rem;
    font-weight: bold;
  }

  #course_pay_entry_outer .download-list {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    margin-top: 5px;
  }

  #course_pay_entry_outer .download-list > a {
    font-weight: bold;
    color: #5aa3f1;
  }

  #course_pay_entry_outer .bottom-buttons .el-button {
    border-color: transparent;
    font-size: 1.5rem;
    border-radius: 30px;
  }

  #course_pay_entry_outer .entry-doing {
     color: white;
     background-color: #fc1a34;
  }

  #course_pay_entry_outer .entry-ready {
    color: lightgray;
    background-color: #fc1a34;
  }

  #course_pay_entry_outer .entry-done {
    color: lightgray;
    background-color: #fc1a34;
  }

</style>



// WEBPACK FOOTER //
// src/components/course/CoursePayEntry.vue